import { render, staticRenderFns } from "./assign-clinic-list.vue?vue&type=template&id=cd488e80&"
import script from "./assign-clinic-list.vue?vue&type=script&lang=js&"
export * from "./assign-clinic-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports